export default "__VITE_ASSET__DWrsW0Ql__"